import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { PendingsOrdersImportModel } from 'src/app/models/imports/pendings-orders-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';


@Component({
  selector: 'app-import-orders',
  templateUrl: './import-orders.component.html',
  styleUrls: ['./import-orders.component.scss'],
  standalone: false,
})
export class ImportOrdersComponent implements OnInit, OnDestroy {

  formImport: FormGroup = new FormGroup({});
  branchCode: number | null = null;
  branchId: number = 0;
  companyCode: number | null = null;
  companyId: number | null = null;

  errorPendingOrder: number = 0;
  eventFile: any;
  listBranches: any[] = [];
  listCompanies: any[] = [];
  listTypes: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Pedidos';
  pendingsOrdersAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  typeId: number = 0;
  typeCode: number = 0;
  isOpened: string | undefined = undefined;
  url: string = "";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;

  constructor(private branchService: BranchService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private router: Router,
    private orderService: OrderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    await this.getAllLists();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  clearForm() {
    this.formImport.controls['companyId'].patchValue(0);
    this.formImport.controls['branchId'].patchValue(0);
    this.formImport.controls['typeId'].patchValue(0);
    this.clearInputFile();
  }

  downloadErrorsTxt() {
    if (!this.pendingsOrdersAlerts || this.pendingsOrdersAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.invoiceService.exportImportErrors(this.pendingsOrdersAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionPedidosPendientes_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.orderService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaPedidos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getAllLists() {
    try {
      const [companies, branches, types] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.orderService.getAllOrderTypesForSelect(),)
      ]);
      this.listCompanies = companies;
      this.listBranches = branches;
      this.listTypes = types;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null && branchId != 0) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
    } else {
      this.branchCode = null;
      this.branchId = 0;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.companyCode = null;
      this.listBranches = [];
      this.validateForm();
    }
  }

  async getType(typeId: number) {
    if (typeId != null && typeId != 0) {
      const type = this.listTypes.find(x => x.value == typeId);
      this.typeId = typeId;
      this.typeCode = type.value;
    } else {
      this.typeId = 0;
      this.typeCode = 0;
      this.formImport.controls['typeId'].patchValue(0);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil por URL.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(
      filter(user => user && user.userId !== 0)
    )
    );
  }

  importPendingsOrders() {
    this.pendingsOrdersAlerts = [];
    this.errorPendingOrder = 0;
    this.visibleTxt = false;
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById('fileImport') as any;
      const rowsImports = new Array<PendingsOrdersImportModel>();
      let row: PendingsOrdersImportModel;
      let counter: number = 1, consecutive: number = 0, dateOrder: Date = new Date(),
        orderStateId: number = 0, costCenterCode: number = 0, purchaseOrderNumber: string = "",
        advertiser: string = "", observation: string = "", remissionObservation: string = "",
        articleCode: number = 0, initialQuantity: number = 0, remissionQuantity: number = 0,
        unitValue: number = 0, compromiseDate: Date = new Date();

      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast(
              'error',
              'El archivo ingresado no iene registros para importar.'
            );
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna A, Fila ${counter}. El código de la compañía no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }
            if (companyCode != this.companyCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna A, Fila ${counter}. La compañía del archivo no es igual a la compañía seleccionada.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Sucursal:
            const branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna B, Fila ${counter}. El código de la sucursal no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }
            if (branchCode != this.branchCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna B, Fila ${counter}. La sucursal del archivo no es igual a la sucursal seleccionada.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            //C. Consecutivo:
            consecutive = parseFloat(element[2] as string);
            if (isNaN(consecutive)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna C, Fila ${counter}. El consecutivo no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            //D. Código Tipo:
            const typeCode = parseFloat(element[3] as string);
            if (isNaN(typeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna D, Fila ${counter}. El código del tipo no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }
            if (typeCode != this.typeCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna D, Fila ${counter}. El tipo de pedido no es igual al tipo seleccionado.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // E. Orden de Compra:
            purchaseOrderNumber = element[4] as string;
            if (purchaseOrderNumber != null && purchaseOrderNumber.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna E, Fila ${counter}. La orden de compra supera el tamaño máximo de caracteres (15).`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // F. Fecha:
            dateOrder = new Date(element[5] as string);
            if (isNaN(dateOrder.getTime())) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna F, Fila ${counter}. La fecha no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            //Convierte fecha de string a Date
            dateOrder = moment(dateOrder, 'DD/MM/YYYY').toDate();
            if (!moment(dateOrder, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna F, Fila ${counter}. La fecha no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // G. Estado Pedido:
            orderStateId = parseFloat(element[6] as string);
            const validOrderStates = [1, 2, 3, 4];
            if (isNaN(orderStateId) || !Number.isInteger(orderStateId) || !validOrderStates.includes(orderStateId)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna G, Fila ${counter}. El estado del pedido no es válido. Valores permitidos: 1 (Abierto), 2 (cierre inicial), 3 (cierre final), 4 (Anulado).`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // H. Código Centro de Costos:
            costCenterCode = parseFloat(element[7] as string);
            if (isNaN(costCenterCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna H, Fila ${counter}. El código del centro de costos no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // I. Anunciante:
            advertiser = element[8] as string;
            if (advertiser != null && advertiser.length > 70) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna I, Fila ${counter}. El anunciante supera el tamaño máximo de caracteres (70).`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // J. Observacion:
            observation = element[9] as string;
            if (observation != null && observation.length > 250) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna J, Fila ${counter}. La observación supera el tamaño máximo de caracteres (250).`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // K. Observacion remisión:
            remissionObservation = element[10] as string;
            if (remissionObservation != null && remissionObservation.length > 250) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna K, Fila ${counter}. La observación de la remisión supera el tamaño máximo de caracteres (250).`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // L. Código Artículo:
            articleCode = parseFloat(element[11] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna L, Fila ${counter}. El código del artículo no es válido.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // M. Cantidad Inicial:
            initialQuantity = parseFloat(element[12] as string);
            if (isNaN(initialQuantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna M, Fila ${counter}. La cantidad inicial no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // N. Cantidad Remisión:
            remissionQuantity = parseFloat(element[13] as string);
            if (isNaN(remissionQuantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna N, Fila ${counter}. La cantidad de remisión no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            // O. Valor Artículo:
            const valueInitialValue = element[14] as string;
            if (valueInitialValue == null || valueInitialValue === "") {
              unitValue = 0; // Asignamos 0 por defecto
            } else {
              unitValue = Number(valueInitialValue);
              if (isNaN(unitValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna N, Fila ${counter}. El valor del artículo no es válido.`;
                this.pendingsOrdersAlerts.push(alert);
                rowHasError = true;
              }
            }

            // P. Fecha de compromiso:
            compromiseDate = new Date(element[15] as string);
            if (isNaN(compromiseDate.getTime())) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna P, Fila ${counter}. La fecha de compromiso no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }
            //Convierte fecha de string a Date
            compromiseDate = moment(compromiseDate, 'DD/MM/YYYY').toDate();
            if (!moment(compromiseDate, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna O, Fila ${counter}. La fecha de compromiso no es válida.`;
              this.pendingsOrdersAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new PendingsOrdersImportModel(counter, this.companyId!, this.branchId, consecutive, this.typeId, purchaseOrderNumber,
                dateOrder, orderStateId, costCenterCode, advertiser, observation, remissionObservation, articleCode, initialQuantity,
                remissionQuantity, unitValue, compromiseDate);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });

          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.orderService.importPendingsOrders(rowsImports));
              this.loadPreInvoicingModel = response;
              this.pendingsOrdersAlerts = response?.alerts ?? [];
              this.errorPendingOrder = response?.preInvoicingStateId;

              if (this.errorPendingOrder === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR'
                );
              } else if (this.pendingsOrdersAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'warning',
                  'La importación terminó con alertas, puede exportarlas si lo desea'
                );
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast(
                  'success',
                  `La importación terminó exitosamente.`
                );
              }
              this.clearForm();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar pedidos.', error);
            }
          } else {
            this.errorPendingOrder = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'No ha seleccionado ningún archivo.'
        );
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      },
      typeId: {
        required: 'El tipo de pedido es obligatorio.',
        min: 'El tipo de pedido es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      typeId: [0, [Validators.required, Validators.min(1)]]
    });
  }
}